import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import Email from './Email'
import DatePickers from './DatePicker'
import ShortText from './ShortText'
import LongText from './LongText'

const ResearchLabCheckInForm = () => {
    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم ثبت نام در آزمایشگاه تحقیقاتی'} subHeader={'لطفا برای ورود به آزمایشگاه تحقیقاتی، این فرم را پر کنید.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'} />
                <Email header={'آدرس ایمیل'} />
                <DatePickers header={'تاریخ و زمان ورود'} />
                <LongText header={'هدف از بازدید'} />
                <ShortText header={'نام سرپرست آزمایشگاه'} />
            </Grid>
        </Grid>
    )
}

export default ResearchLabCheckInForm
